export const isAbsolute = (url: string) => !!/^(https?:)?\/\//.exec(url);
